import * as React from 'react';
import { FC } from 'react';
import useInputErrorsDebouncer from 'app/useInputErrorsDebouncer';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import type { Values, ChangeValues, Errors } from './types';
import Spinner from './Spinner';
import PromocodeIcon from './images/icon_promocode.svg';
import { MAX_LENGTH } from './useSignupCodeValidation';

const SignupCode: FC<{
  values: Values;
  changeValues: ChangeValues;
  errors: Errors;
  locales: Locales;
  isValidating: boolean;
}> = ({ values, changeValues, errors, locales, isValidating }) => {
  const signupCode = values.signup_code;
  const signupCodeErrors = errors.signup_code || [];
  const [canShowErrors, delayErrors] = useInputErrorsDebouncer();
  const showErrors = signupCode && canShowErrors;

  return (
    <div className="signup_code">
      <div className="rs-row">
        <div id="signup_code_label" className="signup_code_title rs-text-align_center">
          {translation(locales, 'attributes.signup_code')}
        </div>
        <div className="signup_code_text rs-text-align_center">
          <p className="small-text">{translation(locales, 'signup_code.hint')}</p>
        </div>
        <div className={`input ${showErrors && signupCodeErrors.length ? 'error' : ''}`}>
          <div className="input-with-icon xo-form_input-iconfull">
            <input
              aria-labelledby="signup_code_label"
              name="player[signup_code]"
              id="player_signup_code"
              value={signupCode}
              placeholder={translation(locales, 'attributes.signup_code')}
              className="sign_input xo-form_input"
              onChange={(e) => {
                const code = e.target.value;
                if (code.length <= MAX_LENGTH) {
                  changeValues({ signup_code: code });
                  delayErrors();
                }
              }}
            />
            <label htmlFor="player_signup_code" className="xo-form_input-label" aria-label="signup_code_label">
              <span className="xo-form_label-placeholder">{translation(locales, 'attributes.signup_code')}</span>
              <span className="xo-form_input-image">
                <img src={PromocodeIcon} alt="icon" />
              </span>
            </label>
            <span className="icon" />
            {isValidating && <Spinner />}
          </div>
          <div className="hints">{showErrors && <small className="error">{signupCodeErrors.join(', ')}</small>}</div>
        </div>
      </div>
    </div>
  );
};

export default SignupCode;
